import { connect } from "react-redux";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import React, { useState } from "react";
import { Input } from "../forms/input";
import Signbutton from "../forms/button";
import {
  SendOtp_EmailorMOB,
  Verify_EmailorMOB,
  SaveEmailMobile_Login,
} from "../../store/actions";
import {
  emailRegex,
  mobileRegex,
  otpRegex,
} from "../home/transactions/newInvestor";
import Image from "../Image";
import { sassFalse } from "sass";

const EmailMobileRegistration = (props) => {
  const initialState = {
    mobile: { value: "" },
    email: { value: "" },
    mobileOTP: { value: "" },
    emailOTP: { value: "" },
    mobileOtpOpen: false,
    emailOtpOpen: false,
    otpIdEmail: "",
    otpIdMobile: "",
    successMessage: { mobile: false, email: false },
  };
  const [state, setState] = useState(initialState);
  const clearState = () => {
    setState(initialState);
  };

  const handleChange = (label) => (event) => {
    const value = event.target.value;
    setState({ ...state, [label]: { value } });
  };

  const handleOTPSubmit = async (label) => {
    const requestData = {
      Mode: label === "mobile" ? "M" : "E",
      [label === "mobile" ? "Mobile" : "Email"]: state[label].value,
    };

    const response = await props.SendOtp_EmailorMOB(requestData);
    if (label === "mobile") {
      setState({
        ...state,
        otpIdMobile: response?.DtData[0]?.Slno,
        [`${label}OtpOpen`]: true,
      });
    } else {
      setState({
        ...state,
        otpIdEmail: response?.DtData[0]?.Slno,
        [`${label}OtpOpen`]: true,
      });
    }
  };

  const VerifyOTP = async (label) => {
    try {
      const labelHeading = "mobile" ? "mobileOTP" : "emailOTP";
      let callingSaveAPI = false;
      const otp = state[label === "mobile" ? "mobileOTP" : "emailOTP"];
      if (label === "mobile" || label === "email") {
        const response1 = await props.Verify_EmailorMOB({
          otpid: label === "mobile" ? state.otpIdMobile : state.otpIdEmail,
          otp: otp.value,
        });

        if (
          response1 &&
          !response1.error &&
          response1.Dtinformation[0].Error_Message === "Valid"
        ) {
          callingSaveAPI =
            label === "mobile"
              ? state.successMessage.email === true
              : state.successMessage.mobile === true;
          setState({
            ...state,
            successMessage: { ...state.successMessage, [label]: true },
          });
          if (callingSaveAPI) {
            await props.SaveEmailMobile_Login({
              Userid: props.userid,
              Email: state.email.value,
              Mobile: state.mobile.value,
            });
          }
        } else {
          setState({
            ...state,
            [labelHeading]: {
              value: state[labelHeading].value,
              isError: true,
              errorMessage: "Enter valid OTP",
            },
          });
        }
      }
    } catch (error) {
      alert(error);
    }
  };
  const handleBlur = (label) => {
    const isMobile = label === "mobile";
    const isEmail = label === "email";
    const isOTP = label === "mobileOTP" || label === "emailOTP";

    const isValidMobile = isMobile && !mobileRegex.test(state.mobile.value);
    const isValidEmail = isEmail && !emailRegex.test(state.email.value);
    const isValidOTP = isOTP && !otpRegex.test(state[label].value);

    if (isMobile || isEmail || isOTP) {
      setState({
        ...state,
        [label]: {
          value: state[label].value,
          isError: isValidMobile
            ? true
            : isValidEmail
            ? true
            : isValidOTP
            ? true
            : false,
          errorMessage: isMobile
            ? "Enter valid mobile number"
            : isEmail
            ? "Enter valid email"
            : isValidOTP
            ? "Enter valid OTP"
            : "",
        },
      });
    }
  };
  const SubmitPage = () => {
    props.close();
    clearState();
  };

  return (
    <div>
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={props.open}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle id="customized-dialog-title" />
        <DialogContent>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: 20,
              fontFamily: "OpenSans-Bold",
              margin: "30px 10%",
            }}
          >
            "Mobile Number and Email Registration"
          </div>
          <div
            style={{
              position: "absolute",
              zIndex: 999,
              right: 5,
              top: 5,
              cursor: "pointer",
            }}
            onClick={props.close}
          >
            <Image
              src={"/images/cross.svg"}
              style={{
                height: 20,
                width: 20,
                cursor: "pointer",
              }}
            />
          </div>
        </DialogContent>
        <div className="grid-container-login">
          <div>
            <Input
              value={state.mobile.value}
              onChange={handleChange("mobile")}
              onBlur={() => handleBlur("mobile")}
              name="Mobile Number"
              type="number"
              isShowError={state.mobile.isError}
              isError={state.mobile.isError}
              errorMessage={state.mobile.errorMessage}
              placeholder="Enter Mobile Number"
            />
            <div
              className="dual-margin"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Signbutton
                buttontitle={state.mobileOtpOpen ? "ReSend OTP" : "Send OTP"}
                onClick={() => handleOTPSubmit("mobile")}
                width={150}
                style="center"
                padding="10px 25px"
                disabled={state.successMessage.mobile}
              />
            </div>
            {state.mobileOtpOpen && (
              <div className="text-otp">OTP has been sent to mobile number</div>
            )}
          </div>
          <div>
            <Input
              value={state.email.value}
              onChange={handleChange("email")}
              onBlur={() => handleBlur("email")}
              name="Email Address"
              isError={state.email.isError}
              isShowError={state.email.isError}
              errorMessage={state.email.errorMessage}
              placeholder="Enter Email Address"
              maxLengthOverride={true}
            />
            <div
              className="dual-margin"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Signbutton
                buttontitle={state.emailOtpOpen ? "ReSend OTP" : "Send OTP"}
                onClick={() => handleOTPSubmit("email")}
                width={150}
                style="center"
                padding="10px 25px"
                disabled={state.successMessage.email}
              />
            </div>
            {state.emailOtpOpen && (
              <div className="text-otp">OTP has been sent to email address</div>
            )}
          </div>
          <div>
            {state.mobileOtpOpen && (
              <>
                <Input
                  value={state.mobileOTP.value}
                  onChange={handleChange("mobileOTP")}
                  onBlur={() => handleBlur("mobileOTP")}
                  name="Mobile Number OTP"
                  type="number"
                  isError={state.mobileOTP.isError}
                  isShowError={state.mobileOTP.isError}
                  errorMessage={state.mobileOTP.errorMessage}
                  placeholder="Enter Mobile OTP"
                />
                <Signbutton
                  buttontitle="Verify OTP"
                  onClick={() => VerifyOTP("mobile")}
                  width={150}
                  center
                  disabled={state.successMessage.mobile}
                />
              </>
            )}
            {state.successMessage.mobile && (
              <div className="text-success">
                Mobile Number Registered Successfully
              </div>
            )}
          </div>
          <div>
            {state.emailOtpOpen && (
              <>
                <Input
                  value={state.emailOTP.value}
                  onChange={handleChange("emailOTP")}
                  onBlur={() => handleBlur("emailOTP")}
                  name="Email Address OTP"
                  type="number"
                  isError={state.emailOTP.isError}
                  isShowError={state.emailOTP.isError}
                  errorMessage={state.emailOTP.errorMessage}
                  placeholder="Enter Email OTP"
                />
                <Signbutton
                  buttontitle="Verify OTP"
                  onClick={() => VerifyOTP("email")}
                  width={150}
                  center
                  disabled={state.successMessage.email}
                />
              </>
            )}
            {state.successMessage.email && (
              <div className="text-success">
                Email Address Registered Successfully
              </div>
            )}
          </div>
        </div>
        {state.successMessage.email && state.successMessage.mobile && (
          <div style={{ paddingBottom: 30 }}>
            <Signbutton
              buttontitle="Proceed to Login"
              onClick={SubmitPage}
              width={150}
              center
            />
          </div>
        )}
      </Dialog>
    </div>
  );
};

export default connect(({ authReducer }) => ({ token: authReducer.token }), {
  SendOtp_EmailorMOB,
  Verify_EmailorMOB,
  SaveEmailMobile_Login,
})(EmailMobileRegistration);
